import TableCell from './TableCell';
import { IColumn, IData } from './types';

interface ITableRow {
  columns: IColumn[];
  data: IData;
  rowIndex: number;
}

const TableRow = (props: ITableRow) => {
  const { columns, data, rowIndex } = props;

  return (
    <tr className="static-table__row">
      {columns.map((column, index) => (
        <TableCell
          column={column}
          key={index}
          rowIndex={rowIndex}
          data={data}
        />
      ))}
    </tr>
  );
};

export default TableRow;
